import generalMutations from "./generalMutations";
import generalActions from "./generalActions";
import _ from "lodash";

export default {
  namespaced: true,
  state: {
    objects: {},
    className: "MealOrderDish",
    version: 0,
  },

  mutations: {
    ...generalMutations,
  },
  actions: {
    ...generalActions,
  },
};
